import React from 'react';
import { InputMoney, InputText, InputPercent } from '../../../Inputs';
import TableRow from '../../TableRow/TableRow';

const ResidentialSellersNetBody = ({
  commission,
  ownersPolicyPremium,
  assessmentRecoupmentCharge,
  attorneyFee,
  recordingFees,
  taxCertificateFee,
  settlementClosingFee,
  numberOfDaysProrate,
  surveyAmendmentT1RResult,
  prorate,
  formProps,
  t19Owner,
  totals,
  ...props
}) => {
  // destructuring the totals
  const { totalClosingCost, totalNetToSeller } = totals;

  return (
    <tbody>
      <TableRow type="input" label="Payoff – First Mortgage">
        <InputMoney {...formProps} name="payOffFirstMortgage" />
      </TableRow>
      <TableRow type="input" label="Payoff – Second Mortgage">
        <InputMoney {...formProps} name="payOffSecondMortgage" />
      </TableRow>
      <TableRow type="input" label="Payoff – Other">
        <InputMoney {...formProps} name="payOffOther" />
      </TableRow>
      <TableRow label="Commission" className="tr--section" colSpan="2" />
      <TableRow type="input" label="% Commission">
        <InputPercent {...formProps} name="percentCommission" />
      </TableRow>
      <TableRow label="Commission" valueType="currency" value={commission} />
      <TableRow
        label="Title Company Fees"
        className="tr--section"
        colSpan="2"
      />
      <TableRow
        label="Owner's Policy Premium"
        valueType="currency"
        value={ownersPolicyPremium}
      />
      <TableRow
        label="Policy Guaranty Fee"
        valueType="currency"
        value={assessmentRecoupmentCharge}
      />
      <TableRow
        label="Survey Amendment to T-1R Policy"
        valueType="currency"
        value={surveyAmendmentT1RResult}
      />
      <TableRow
        label="T-19.1 (Rest/Encro/Minerals)"
        valueType="currency"
        value={t19Owner}
      />
      <TableRow
        label="Attorney Fee (Deed/Release)"
        valueType="currency"
        value={attorneyFee}
      />
      <TableRow
        label="Recording Fees (Per Release)"
        valueType="currency"
        value={recordingFees}
      />
      <TableRow
        label="Tax Certificate Fee"
        valueType="currency"
        value={taxCertificateFee}
      />
      <TableRow
        label="Settlement/Closing Fee"
        valueType="currency"
        value={settlementClosingFee}
      />
      <TableRow label="Tax Prorations" className="tr--section" colSpan="2" />
      <TableRow type="input" label="Annual Tax Amount">
        <InputMoney {...formProps} name="annualTaxAmmount" />
      </TableRow>
      <TableRow
        label="Number of Days to Prorate"
        valueType="number"
        value={numberOfDaysProrate}
      />
      <TableRow label="Prorate Total" valueType="currency" value={prorate} />
      <TableRow label="Other" className="tr--section" colSpan="2" />
      <TableRow type="input" label="Unpaid HOA Dues">
        <InputMoney {...formProps} name="unpaidHoaDues" />
      </TableRow>
      <TableRow type="input" label="HOA Transfer Fee">
        <InputMoney {...formProps} name="hoaTransferFee" />
      </TableRow>
      <TableRow type="input" label="Resale Certificate Fee">
        <InputMoney {...formProps} name="resaleCertificateFee" />
      </TableRow>
      <TableRow type="input" label="Home Warranty Fee">
        <InputMoney {...formProps} name="homeWarrentyFee" />
      </TableRow>
      <TableRow type="input" label="Survey">
        <InputMoney {...formProps} name="survey" />
      </TableRow>
      <TableRow type="input" label="Seller Paid Borrower Closing Cost">
        <InputMoney {...formProps} name="sellerPaidBorrowerClosingCost" />
      </TableRow>
      <TableRow type="input" label="Option Money Credit">
        <InputMoney {...formProps} name="optionMoneyCredit" />
      </TableRow>
      <TableRow type="input" label="Other">
        <InputMoney {...formProps} name="other1" />
      </TableRow>
      <TableRow type="input" label="Other">
        <InputMoney {...formProps} name="other2" />
      </TableRow>
      <TableRow
        label="Estimated Closing Cost"
        valueType="currency"
        value={totalClosingCost}
        className="tr--result"
      />
      <TableRow
        label="Estimated Net to Seller"
        valueType="currency"
        value={totalNetToSeller}
        className="tr--result"
      />
    </tbody>
  );
};

export default ResidentialSellersNetBody;
